// Core
import React, { useState } from "react"
import styled from "styled-components"
import classNames from "classnames"

// Components
import BaseContainer from "../../../../../../components/BaseContainer"
import Paragraph from "../../../../../../components/Paragraph"
import size from "../../../../../../styles/size"

const Section = styled.section`
  background-color: #ffffff;
  color: #555555;

  .creed {
    text-align: center;
    width: 100%;
    width: 30rem;
    margin-right: 5rem;
  }

  .creed:last-child {
    margin-right: 0;
  }

  .title {
    font-weight: 700;
    font-size: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .semi-hidden-text {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .hide {
    display: none;
  }

  .show-more {
    margin-top: 1.5rem;
    font-weight: 500;

    a {
      color: #60a6dd;
    }
  }

  @media (max-width: ${size.laptop}) {
    .creed {
      margin-bottom: 7rem;
      margin-right: 0;
      width: 100%;
    }

    .creed:last-child {
      margin-bottom: 0;
    }
  }
`

export default function Creed() {
  const [hiddenPilares, setHiddenPilares] = useState(true)
  const [hiddenCultura, setHiddenCultura] = useState(true)

  function showPilares(e) {
    e.preventDefault()
    setHiddenPilares(false)
  }

  function showCultura(e) {
    e.preventDefault()
    setHiddenCultura(false)
  }

  return (
    <Section>
      <BaseContainer style={{ justifyContent: "center" }}>
        <div className="creed">
          <div className="title">NOSSA MISSÃO</div>

          <Paragraph center>
            Ser uma igreja que ama servindo e conectando pessoas a Cristo.
          </Paragraph>
        </div>

        <div className="creed">
          <div className="title">NOSSA VISÃO</div>
          <Paragraph center>
            Conectar todas as pessoas a Deus com amor e graça.
          </Paragraph>
        </div>

        <div className="creed">
          <div className="title">NOSSOS PILARES</div>
          <Paragraph
            center
            className={classNames({
              "semi-hidden-text": hiddenPilares,
            })}
          >
            A adoração como estilo de vida, o serviço como resposta prática de
            amor, a comunhão como forma de ser família, o discipulado como
            maneira de desenvolver a fé e o evangelismo como expressão viva do
            amor de Deus por nós são os pilares da nossa forma de ser igreja.
          </Paragraph>

          <div
            className={classNames({
              "show-more": true,
              hide: !hiddenPilares,
            })}
          >
            <a href="/" onClick={showPilares}>
              Ver mais
            </a>
          </div>
        </div>

        <div className="creed">
          <div className="title">NOSSA CULTURA</div>
          <Paragraph
            center
            className={classNames({
              "semi-hidden-text": hiddenCultura,
            })}
          >
            Somos uma igreja bíblica, relevante e contemporânea que ama servindo
            em família e que serve amando voluntariamente cada um individual e
            coletivamente. Uma comunidade de pessoas reais, imperfeitas e amadas
            que vive continuamente conhecendo a graça de Deus e amadurecendo a
            fé para fazê-la conhecida a toda sorte de pessoas. Uma agência de
            relevância e transformação da realidade social em que estiver
            inserida.
          </Paragraph>

          <div
            className={classNames({
              "show-more": true,
              hide: !hiddenCultura,
            })}
          >
            <a href="/" onClick={showCultura}>
              Ver mais
            </a>
          </div>
        </div>
      </BaseContainer>
    </Section>
  )
}
